import Container from "../../../../components/container";
import Icon from "../../../../components/icon";
import { EventOccasion } from "../../../../models";
import { DeleteEventOccasion, UpdateEventOccasion } from "./buttons";

export default function EventOccasionsTable({
  eventOccasions,
}: {
  eventOccasions: EventOccasion[];
}) {
  return (
    <Container className=" max-w-2xl">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {eventOccasions?.map((eventOccasion) => (
          <div
            key={eventOccasion.id}
            className="mb-2 w-full rounded-md bg-white p-4"
          >
            <h2 className="text-lg font-semibold">{eventOccasion.name}</h2>            
            <div className="flex items-center justify-between pb-4 mt-2">
              {eventOccasion.id ? (
                <div className="w-full flex items-center justify-center gap-2">
                  <UpdateEventOccasion id={eventOccasion.id.toString()} />
                  <DeleteEventOccasion id={eventOccasion.id.toString()} />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>            
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3 text-center">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {eventOccasions.map((eventOccasion) => (
            <tr key={eventOccasion.id} className="border-b">              
              <td className="px-6 py-4 font-medium">{eventOccasion.name}</td>
              <td className="px-6 py-4">
                {eventOccasion.id ? (
                  <div className="flex items-center justify-center gap-2">
                    <UpdateEventOccasion id={eventOccasion.id.toString()} />
                    <DeleteEventOccasion id={eventOccasion.id.toString()} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}



